export default {
  created() {
    const { titleKey } = this.$options;
    if (titleKey) {
      const translation = this.$t(titleKey);
      document.title = `${translation} | ${process.env.VUE_APP_TITLE}`;
    }
  },
};
